import { useCallback, useEffect, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { IAdContent } from 'src/interface';
import { tracking as trackingImg } from 'src/utils/tracking';

export const useTrackingActive = (adNative?: IAdContent) => {
    const [inViewRef, inView] = useInView({ triggerOnce: false, threshold: 1 });
    const [isTracking, setIsTracking] = useState<boolean>(false);
    const inViewState = useRef(inView);
    useEffect(() => {
        inViewState.current = inView;
        if (!isTracking) {
            setTimeout(() => {
                checkInView();
            }, 1000);
        }
    }, [inView, isTracking]);

    const checkInView = useCallback(() => {
        if (inViewState.current) {
            const activeView = adNative?.tracking.activeView[0] || '';
            trackingImg(activeView, {});
            setIsTracking(true);
        }
    }, [inViewState, adNative]);

    return inViewRef;
};
